import { Box, MenuItem, Select, Typography } from "@mui/material";
import Skeleton from "react-loading-skeleton";
const CustomDropDown = ({
  disabled,
  value,
  onChange,
  NoData,
  menuList,
  placeholder,
  sx = {},
  style = {},
  errors,
  Title,
  isLoading,
  getLabel,
  name,
  onBlur,
  onKeyUp,
  required
}) => {
  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {Title && (
          <Typography
            sx={{
              color: "black",
              fontWeight: "400",
              textAlign: "left",
              fontSize: { xs: "16px", sm: "18px" },
              ...style,
              position: "relative",
              display: "flex",

            }}
            aria-required={required}
          >
            {Title}
            {required && (
              <span style={{
                color: "red"
              }}>*</span>
            )}
          </Typography>

        )}
        {isLoading ? (
          <Skeleton height={"60px"} />
        ) : (
          <Select
            sx={{
              width: "100%",
              height: "54px",
              border: errors ? "1px solid red" : "1px solid #BB9EFF",
              borderRadius: "10px",
              "&:focus": {
                outline: "none",
                boxShadow: "none",
              },
              "&:hover": {
                outline: "none",
              },
              ".MuiOutlinedInput-notchedOutline": {
                border: errors ? "1px solid red" : "none",
              },
              ...sx,
            }}
            name={name}
            value={value}
            onChange={onChange}
            displayEmpty
            disabled={disabled}
            onBlur={onBlur}
            onKeyUp={onKeyUp}
          >
            <MenuItem value={0} disabled>
              {placeholder}
            </MenuItem>
            {menuList ? (
              menuList.map((elem, index) => (
                <MenuItem key={index} value={elem.id}>
                  {getLabel ? (elem?.name || elem?.title) : elem?.category_name}
                </MenuItem>
              ))
            ) : (
              <Typography>{NoData}</Typography>
            )}
          </Select>
        )}
        {errors && (
          <Typography
            sx={{
              color: "red",
              fontWeight: "400",
              fontSize: { xs: "14px", sm: "14px" },
              marginTop: "5px",
            }}
          >
            {errors}
          </Typography>
        )}
      </Box>
    </>
  );
};

export default CustomDropDown;
